import { render, staticRenderFns } from "./TopShareBar.vue?vue&type=template&id=2356c576&scoped=true&"
import script from "./TopShareBar.vue?vue&type=script&lang=js&"
export * from "./TopShareBar.vue?vue&type=script&lang=js&"
import style0 from "./TopShareBar.vue?vue&type=style&index=0&id=2356c576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356c576",
  null
  
)

export default component.exports